import { handleActions } from 'redux-actions';

import {
  onValidRecaptcha,
  onExpiredReCapture,
  requestRecaptureUpdate,
  updateRecapture,
  resetRecaptureState,
} from '@app/actions/recaptchaActions';

const initialState = {
  isReCaptureValid: false,
  shouldRecaptureBeUpdated: false,
  token: '',
};

export default handleActions({
  [onValidRecaptcha]: (state, { payload }) => ({
    ...state,
    isReCaptureValid: true,
    token: payload,
  }),
  [onExpiredReCapture]: state => ({
    ...state,
    isReCaptureValid: false,
  }),
  [requestRecaptureUpdate]: state => ({
    ...state,
    shouldRecaptureBeUpdated: true,
    isReCaptureValid: false,
  }),
  [updateRecapture]: state => ({
    ...state,
    shouldRecaptureBeUpdated: false,
  }),
  [resetRecaptureState]: () => ({
    ...initialState,
  }),
}, initialState);
